import EditorCloseIcon from '../Icon/EditorCloseIcon.js';

//
var script = {
  name: 'Tag',
  components: {
    EditorCloseIcon
  },
  props: {
    tag: {
      type: Object,
      default: () => ({})
    },
    index: {
      type: Number,
      required: true
    },
    count: {
      type: Number,
      required: true
    },
    min: {
      type: Number,
      default: 0
    }
  },

  data() {
    return {};
  },

  computed: {
    shouldShowRemoveButton() {
      return this.min !== this.count && !this.tag.disabled;
    }

  },
  methods: {
    onRemove() {
      this.$emit('on-remove', this.tag.id);
    },

    onDragStart(e) {
      this.$emit('dragstart', e, this.index);
    },

    onDragEnd(e) {
      this.$emit('dragend', e);
    },

    onDrag(e) {
      this.$emit('drag', e);
    }

  }
};

export default script;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/Select/Tag.vue_rollup-plugin-vue=script.js